
// 正式
const baseUrl = window.serverConfig.baseUrl;
const socketUrl = 'http://117.159.39.2:8910'; // socket链接
const iframeBaseUrlAdmin = 'http://192.168.3.65:8010';

export {
  baseUrl,
  iframeBaseUrlAdmin,
  socketUrl
};



// WEBPACK FOOTER //
// ./src/http/baseUrl.js